import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MemberNoteService } from 'src/app/project-display/data-access/member-note.service';
import { IProjectNote } from 'src/app/project-display/interfaces/IProjectNote';

interface DeleteMemberNoteDialogData {
  memberNote: IProjectNote;
}

@Component({
  selector: 'eic-delete-member-note-dialog',
  templateUrl: './delete-member-note-dialog.component.html',
  styleUrl: './delete-member-note-dialog.component.scss'
})
export class DeleteMemberNoteDialogComponent {
  isDeleting = false;

  constructor(
    private dialogRef: MatDialogRef<DeleteMemberNoteDialogComponent>,
    private memberNoteService: MemberNoteService,
    @Inject(MAT_DIALOG_DATA) public data: DeleteMemberNoteDialogData
  ) {
  }

  cancel() {
    this.dialogRef.close();
  }

  delete() {
    if (this.isDeleting) return;

    this.isDeleting = true;
    this.memberNoteService
      .delete(this.data.memberNote.projectNoteID)
      .subscribe({
        next: () => this.dialogRef.close(this.data.memberNote),
        error: () => {
          this.isDeleting = false;
        }
      });
  }
}
